import store from '@/store'

export default [
  {
    path: '/service-locations',
    name: 'service-location',
    meta: { requireAuth: true },
    component: () => import('@/pages/service-location/index.vue')
  },
  {
    path: '/service-locations/create',
    name: 'service-location-create',
    meta: { requireAuth: true },
    component: () => import('@/pages/service-location/create.vue')
  },
  {
    path: '/service-locations/:id',
    name: 'service-location-edit',
    meta: { requireAuth: true },
    component: () => import('@/pages/service-location/edit.vue'),
    props: route => ({ serviceLocation: route.params.serviceLocation }),
    beforeEnter: async (to, from, next) => {
      let response = await store.dispatch('serviceLocation/find', to.params.id)
      let { ...resource } = response.data
      to.params.serviceLocation = resource
      next()
    }
  }
]
